var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCol',{attrs:{"sm":"12"}},[_c('b-card',[_c('b-card-header',[_c('h4',[_vm._v(_vm._s(_vm.title))])]),_c('b-card-body',[_c('l-map',{ref:"myMap",staticStyle:{"height":"600px"},attrs:{"center":[46.165063, 7.448974],"zoom":9}},[_c('l-tile-layer',{attrs:{"url":"http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }